module.exports = __webpack_public_path__ + "static/media/img3.46733691.jpg";